<section
  class="bg-gradient-to-br from-primary via-primary to-blue-900 grid grid-cols-1 md:grid-cols-4 md:p-16 p-6 shadow-strong relative overflow-hidden"
>
  <!-- Decorative background elements -->
  <div
    class="absolute top-0 right-0 w-64 h-64 bg-secondary/5 rounded-full blur-3xl"
  ></div>
  <div
    class="absolute bottom-0 left-0 w-96 h-96 bg-secondary/5 rounded-full blur-3xl"
  ></div>

  <div class="md:col-span-1 md:col-start-1 mb-8 md:mb-0 relative z-10">
    <img
      src="assets/logos/logo-everfull.png"
      class="pb-4 w-44 hidden md:block transition-transform duration-300 hover:scale-105"
      alt="Logo Everfull"
    />
  </div>

  <div
    class="md:col-span-1 md:col-start-2 md:col-end-2 mb-8 md:mb-0 relative z-10"
  >
    <h1 class="text-white font-bold text-lg mb-4 md:mb-6 ml-4 md:ml-0">Menú</h1>
    <ul class="text-white text-sm ml-4 md:ml-0 space-y-3">
      <li>
        <a
          routerLink="/home"
          class="hover:text-secondary transition-all duration-300 hover:translate-x-2 inline-block"
        >
          <svg
            class="inline-block w-4 h-4 mr-2 text-white"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
            />
          </svg>
          Home
        </a>
      </li>
      <li>
        <a
          routerLink="/subscription-month"
          class="hover:text-secondary transition-all duration-300 hover:translate-x-2 inline-block"
        >
          <svg
            class="inline-block w-4 h-4 mr-2 text-white"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
            />
          </svg>
          Productos
        </a>
      </li>
      <li>
        <a
          routerLink="/tyc"
          class="hover:text-secondary transition-all duration-300 hover:translate-x-2 inline-block"
        >
          <svg
            class="inline-block w-4 h-4 mr-2 text-white"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fill-rule="evenodd"
              d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z"
              clip-rule="evenodd"
            />
          </svg>
          Términos y condiciones
        </a>
      </li>
    </ul>
  </div>

  <div
    class="md:col-span-1 md:col-start-3 md:col-end-3 mb-8 md:mb-0 relative z-10"
  >
    <h1 class="text-white font-bold text-lg mb-4 md:mb-6 ml-4 md:ml-0">
      ¿Cómo podemos ayudarte?
    </h1>
    <ul class="text-white text-sm ml-4 md:ml-0 space-y-3">
      <li>
        <a
          routerLink="/clients"
          class="hover:text-secondary transition-all duration-300 hover:translate-x-2 inline-block"
        >
          <svg
            class="inline-block w-4 h-4 mr-2 text-white"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fill-rule="evenodd"
              d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
              clip-rule="evenodd"
            />
          </svg>
          Mi perfil
        </a>
      </li>
      <li>
        <a
          routerLink="/faqs"
          class="hover:text-secondary transition-all duration-300 hover:translate-x-2 inline-block"
        >
          <svg
            class="inline-block w-4 h-4 mr-2 text-white"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fill-rule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
              clip-rule="evenodd"
            />
          </svg>
          Preguntas Frecuentes
        </a>
      </li>
      <li>
        <a
          routerLink="/contact"
          class="hover:text-secondary transition-all duration-300 hover:translate-x-2 inline-block"
        >
          <svg
            class="inline-block w-4 h-4 mr-2 text-white"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
            />
            <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
          </svg>
          Contacto
        </a>
      </li>
    </ul>
  </div>

  <div class="md:col-span-1 md:col-start-4 md:col-end-4 relative z-10">
    <h1 class="text-white font-bold text-lg mb-4 md:mb-6 ml-4 md:ml-0">
      Encontranos en
    </h1>
    <ul class="text-white text-sm ml-4 md:ml-0 space-y-3">
      <li>
        <a
          href="https://www.instagram.com/everfullar/"
          target="_blank"
          class="hover:text-secondary transition-all duration-300 hover:translate-x-2 inline-block"
        >
          <svg
            class="inline-block w-4 h-4 mr-2 text-white"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
            />
          </svg>
          Instagram
        </a>
      </li>

      <li>
        <a
          href="https://www.facebook.com/everfullar/"
          target="_blank"
          class="hover:text-secondary transition-all duration-300 hover:translate-x-2 inline-block"
        >
          <svg
            class="inline-block w-4 h-4 mr-2 text-white"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
            />
          </svg>
          Facebook
        </a>
      </li>

      <li>
        <a
          href="https://ar.linkedin.com/company/everfull-"
          target="_blank"
          class="hover:text-secondary transition-all duration-300 hover:translate-x-2 inline-block"
        >
          <svg
            class="inline-block w-4 h-4 mr-2 text-white"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
            />
          </svg>
          LinkedIn
        </a>
      </li>
    </ul>
  </div>
</section>
